<div class="cyber-modal">
  <div class="modal-header" [ngClass]="{'error-header': data.type === 'error'}">
    <h2 mat-dialog-title class="cyber-title">>_ {{ data.title | uppercase }}</h2>
  </div>
  
  <div mat-dialog-content class="modal-body">
    <p>{{ data.message }}</p>
  </div>

  <div mat-dialog-actions class="modal-footer">
    
    <ng-container *ngIf="data.type === 'confirm'">
      <button class="btn secondary" (click)="onCancel()">CANCELAR</button>
      <button class="btn primary btn-glow" (click)="onConfirm()">CONFIRMAR</button>
    </ng-container>

    <ng-container *ngIf="data.type === 'error'">
      <button class="btn danger" (click)="dialogRef.close()">ENTENDIDO</button>
    </ng-container>
    
    <ng-container *ngIf="data.type !== 'confirm' && data.type !== 'error'">
       <button class="btn primary" (click)="dialogRef.close()">ACEPTAR</button>
    </ng-container>

  </div>
</div>